import { Col, Row } from "antd";
import { useGetFormQuery } from "api/TenantSlug/Form/hooks.ts";
import { FormDesignGeneralForm } from "components/Forms/FormDesignGeneralForm/FormDesignGeneralForm.tsx";
import { QueryState } from "components/UI/QueryState/QueryState.tsx";
import { SectionContentWrapper } from "components/UI/SectionContentWrapper";
import { TenantPage } from "components/UI/TenantPage/TenantPage.tsx";
import { PermissionEnum } from "types/enums.ts";
import { FormId } from "types/models.ts";
import { createTenantFileRoute } from "utils/createTenantFileRoute.ts";
import { getToolDesignFormHeaderItems } from "utils/tenantHeaderItems.ts";

const GET_FORM_QUERY_FILTERS = {
    filter: { include: "formPages,formFields,formStructure,category,labels" },
};

export const Route = createTenantFileRoute(
    "/_authenticated/$tenantSlug/_layout/tool/_layout/design/_layout/form/_layout/$formId/_layout/general/"
)({
    component: FormDesignGeneralPage,
    staticData: {
        permissions: [PermissionEnum.ToolDesignFormGeneral],
        showInSideMenu: false,
        label: "pages.tool.design.form.general.title",
    },
    loader: ({ context: { t } }) => {
        return { breadcrumb: t("pages.tool.design.form.general.title") };
    },
});

function FormDesignGeneralPage() {
    const { formId } = Route.useParams();
    const { data, isLoading, isError } = useGetFormQuery(formId, GET_FORM_QUERY_FILTERS);
    const form = data?.form;

    if (!form) {
        return <QueryState isLoading={isLoading} isError={isError || !isLoading} errorKey="errors.loading_form" />;
    }

    return (
        <TenantPage
            headerNavigationItems={getToolDesignFormHeaderItems}
            isEdit={true}
            saveFormId={FormId.FormDesignGeneralForm}
        >
            <Row>
                <Col span={12}>
                    <SectionContentWrapper withBackground>
                        <FormDesignGeneralForm key={formId} formData={form} />
                    </SectionContentWrapper>
                </Col>
            </Row>
        </TenantPage>
    );
}
